<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'payment'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">Payment History</h1>
						</div>

						<div class="product-infos-wrapper-pc">
							<el-table :data="accountLogList" style="width: 100%" v-loading="tableLoading">
								<el-table-column type="index" width="50" label="#"></el-table-column>
								<el-table-column prop="createTime" label="Date"></el-table-column>
								<el-table-column prop="amount" label="Amount">
									<template v-slot:default="scope">
										<span>
											<!-- 把 1 改成字符串 '1'，匹配接口返回的类型 -->
											{{ scope.row.amtFlag === '1' ? '+' : '-' }}{{ scope.row.amount }}
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="title" label="title"></el-table-column>
							</el-table>
						</div>

						<!-- 分页组件 -->
						<div class="page-contrainer d-flex">
							<el-pagination background :page-count="isMobile ? 4 : 10" layout="prev, pager, next"
								:total="total" :current-page.sync="queryParams.pageNum"
								@current-change="getAccountLogList">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabBar></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		accountLogList
	} from '../../api/accountLog'
	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				tableLoading: false,
				accountLogList: [],
				total: 0,
				pageNo: 1,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				isMobile: false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getAccountLogList();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
			},
			getAccountLogList() {
				accountLogList(this.queryParams).then(res => {
					if (res.code == 200) {
						this.accountLogList = res.rows;
						this.total = res.total;
					} else {
						return false;
					}
				})
			},

			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/review.css");
</style>
<style scoped>



</style>
